module.exports = __webpack_public_path__ + "static/media/Hero-Illustration.cea65ff8.svg";